// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedEnvelopeFilledSvg from "@ant-design/icons-svg/es/asn/RedEnvelopeFilled";
import AntdIcon from '../components/AntdIcon';

var RedEnvelopeFilled = function RedEnvelopeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeFilledSvg
  }));
};

RedEnvelopeFilled.displayName = 'RedEnvelopeFilled';
export default /*#__PURE__*/React.forwardRef(RedEnvelopeFilled);